import { MarkdownEditor, ViewMode } from '@efdigital/ll-addon-codemirror';
import { PageWidgetType } from '@efdigital/ll-addon-data';
import { DataTypeContent } from '@efdigital/ll-addon-data/data-types';
import type {
  PageWidgetAudio,
  PageWidgetAudioLike,
} from '@efdigital/ll-addon-data/types/content/objects/page-widget-audio';
import { uniqueId } from '@ember/helper';
import { on } from '@ember/modifier';
import Component from '@glimmer/component';

import { SidebarAll } from '../../../lib/markdown-toolbar.ts';
import type {
  PageWidgetComponentSignature,
  WidgetEditor,
} from '../page-widget-signature.ts';

export class PageWidgetAudioComponent extends Component<PageWidgetComponentSignature> {
  get widget() {
    return this.args.widget as PageWidgetAudio;
  }

  setMp3 = (event: Event) => {
    const mp3 = (event.target as HTMLInputElement).value;
    this.widget.mp3 = mp3;
  };

  setTranscript = (transcript: string) => {
    this.widget.transcript = transcript;
  };

  setShowTranscript = (event: Event) => {
    const showTranscript = (event.target as HTMLInputElement).checked;
    this.widget.showTranscript = showTranscript;
  };

  <template>
    {{#let (uniqueId) as |uniqueId|}}
      <div class="card-body">
        <div class="form-group mb-4">
          <label for="{{uniqueId}}-mp3">MP3</label>
          <input
            class="form-control"
            id="{{uniqueId}}-mp3"
            type="url"
            value={{this.widget.mp3}}
            {{on "change" this.setMp3}}
          />
        </div>
        <div class="form-group mb-4">
          <label for="{{uniqueId}}-transcript">Transcript</label>
          <MarkdownEditor
            @markdown={{this.widget.transcript}}
            @toolbar={{SidebarAll}}
            @mode={{ViewMode.EditorOnly}}
            @onUpdate={{this.setTranscript}}
          >
            <:preview as |markdown|>
              <pre>{{markdown}}</pre>
            </:preview>
          </MarkdownEditor>
        </div>
        <div class="form-check mb-4">
          <input
            class="form-check-input"
            id="{{uniqueId}}-showTranscript"
            type="checkbox"
            checked={{this.widget.showTranscript}}
            {{on "change" this.setShowTranscript}}
          />
          <label class="form-check-label" for="{{uniqueId}}-showTranscript">Show
            Transcript</label>
        </div>
      </div>
    {{/let}}
  </template>
}

const DEFAULT_WIDGET_AUDIO: Omit<PageWidgetAudioLike, 'wid'> = {
  widgetType: PageWidgetType.Audio,
  title: 'Audio',
  css: '',
  mp3: '',
  transcript: '',
  showTranscript: false,
};

export const AudioWidgetEditor: WidgetEditor = {
  icon: 'ph:headphones-bold',
  label: 'Audio',
  component: PageWidgetAudioComponent,
  dataType: DataTypeContent.PageWidgetAudio,
  widgetData: DEFAULT_WIDGET_AUDIO,
};
